import React from 'react'

function Title() {

  return (<section className="navbar-section">
    <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
    <i className="icon icon-menu icon-2x hvr-pulse c-hand"></i>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
    <span className="h4 c-hand" lang="zh-Hans">小障</span>
  </section>)
}
export default Title



// WEBPACK FOOTER //
// ./src/topModule/Title.js